"use strict";
exports.__esModule = true;
var i18n = window.MTBlockEditor.i18n;
exports["default"] = i18n;
